module.exports = __webpack_public_path__ + "static/media/AerolineasLogo.64882ff5.svg";